var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.031 0.845075C10.031 0.650033 10.9197 0.5 12.0077 0.5C13.0956 0.5 13.9843 0.650033 13.9843 0.845075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7338 1.04012H1.28147C0.858332 1.04012 0.515312 1.37598 0.515312 1.79028V20.5444C0.515312 20.9587 0.858332 21.2945 1.28147 21.2945H22.7338C23.157 21.2945 23.5 20.9587 23.5 20.5444V1.79028C23.5 1.37598 23.157 1.04012 22.7338 1.04012Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4973 4.6259H7.50266C6.65639 4.6259 5.97035 5.29762 5.97035 6.12622V11.9025C5.97035 12.7311 6.65639 13.4028 7.50266 13.4028H16.4973C17.3436 13.4028 18.0297 12.7311 18.0297 11.9025V6.12622C18.0297 5.29762 17.3436 4.6259 16.4973 4.6259Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57994 1.19015V21.2945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16156 13.4478V21.2945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16156 1.19015V4.6259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8231 13.4478V21.2945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8231 1.19015V4.6259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4201 1.19015V21.2945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4847 4.67091V4.6259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8231 4.6259H23.4847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16156 4.6259H15.8231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.6259H8.16156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8231 13.4478H23.4847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16156 13.4478H15.8231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.4478H8.16156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 17.1686H23.4847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0296 9.30691H23.4847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9.30691H5.97036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1016 21.9997H0.883078C0.67151 21.9997 0.5 22.1676 0.5 22.3748V23.1249C0.5 23.3321 0.67151 23.5 0.883078 23.5H23.1016C23.3132 23.5 23.4847 23.3321 23.4847 23.1249V22.3748C23.4847 22.1676 23.3132 21.9997 23.1016 21.9997Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTote);
export default __webpack_public_path__ + "static/media/Tote.c995c17d3a940c2f5c70e8c138c38248.svg";
export { ForwardRef as ReactComponent };